import { Modal, Spinner } from "react-bootstrap";

// RESULTADOS-06F: previsualización del archivo de un documento DENTRO de
// Smartmedic (no nueva pestaña). Componente puramente presentacional: recibe
// el objectURL ya creado por `ModalResultadoExamen` (que también lo revoca).
//
//   - PDF   -> <iframe>
//   - PNG/JPEG -> <img>
//   - Nunca `documento.archivo_url` ni `/store/` (el blob viene del endpoint
//     autenticado 06D `GET .../descargar`).
function ModalPreviewResultadoDocumento({ data }) {
    const { show, handleClose, documento, blobUrl, contentType, onDescargar } = data;

    const ct = String(contentType || "").toLowerCase();
    const esPdf = ct.includes("pdf");
    const esImagen = ct.includes("png") || ct.includes("jpeg") || ct.includes("jpg");
    const etiquetaTipo = esPdf ? "PDF" : esImagen ? "Imagen" : "";

    return (
        <>
            <style>{`.modal-preview-resultado-doc { max-width: 90vw; }`}</style>
            <Modal
                show={show}
                onHide={handleClose}
                size="xl"
                backdrop="static"
                keyboard={true}
                dialogClassName="modal-preview-resultado-doc"
                aria-labelledby="preview-resultado-doc-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title as="div" id="preview-resultado-doc-title">
                        <span>Vista previa — {documento?.tipo_documento_nombre || "Documento"}</span>
                        {etiquetaTipo && <div className="small text-secondary">{etiquetaTipo}</div>}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ minHeight: "60vh" }}>
                    {!blobUrl ? (
                        <div className="text-center text-muted py-5">
                            <Spinner as="span" animation="border" size="sm" /> Cargando documento…
                        </div>
                    ) : esPdf ? (
                        <iframe
                            title="Vista previa del documento"
                            src={blobUrl}
                            style={{ width: "100%", height: "75vh", border: 0 }}
                        />
                    ) : esImagen ? (
                        <div className="text-center">
                            <img
                                src={blobUrl}
                                alt="Vista previa del documento"
                                style={{ maxWidth: "100%", maxHeight: "75vh", objectFit: "contain" }}
                            />
                        </div>
                    ) : (
                        <div className="text-center text-muted py-5">
                            Este formato no se puede previsualizar. Usa <strong>Descargar</strong>.
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <button type="button" className="btn btn-light" onClick={handleClose}>Cerrar</button>
                    <button type="button" className="btn btn-primary" onClick={onDescargar}>Descargar</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalPreviewResultadoDocumento;
